module.exports = __webpack_public_path__ + "img/turmeric-350x184.36a75dba.jpg";